import {
  ListingManagement,
  ListingManagementGray,
  CommissionManagement,
  CommissionManagementGray,
  StageRecord,
  StageRecordGray,
  DepositAndFees,
  DepositAndFeesGray,
  Terms,
  TermsGray,
  ChangeLog,
  ChangeLogGray,
  ReferenceAndContact,
  ReferenceAndContactGray,
} from 'common/components/svgs';
import React from 'react';
import PropTypes from 'prop-types';

export default class HomepageCard extends React.Component {
  constructor() {
    super();
    this.comingSoonType = [];
  }

  render() {
    const { t, type } = this.props;
    return (
      <div
        className={`property-homepage__card 
          property-homepage__${type.replace(/_/g, '-')} 
          ${this.comingSoonType.indexOf(type) !== -1 ? 'property-homepage__card-coming-soon' : ''}`}
      >
        <Choose>
          <When condition={type === 'listing_management'}>
            <ListingManagement className="property-homepage__card-icon" />
            <ListingManagementGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'commission_management'}>
            <CommissionManagement className="property-homepage__card-icon" />
            <CommissionManagementGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'stage_record'}>
            <StageRecord className="property-homepage__card-icon" />
            <StageRecordGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'deposit_and_fees'}>
            <DepositAndFees className="property-homepage__card-icon" />
            <DepositAndFeesGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'terms'}>
            <Terms className="property-homepage__card-icon" />
            <TermsGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'change_log'}>
            <ChangeLog className="property-homepage__card-icon" />
            <ChangeLogGray className="property-homepage__card-icon--gray" />
          </When>
          <When condition={type === 'reference_and_contact'}>
            <ReferenceAndContact className="property-homepage__card-icon" />
            <ReferenceAndContactGray className="property-homepage__card-icon--gray" />
          </When>
        </Choose>
        <div className="property-homepage__card-text">
          <h3 className="property-homepage__card-title">
            {t(`cms.properties.homepage.part.${type}.title`)}
          </h3>
          <span className="property-homepage__coming-soon">
            {t('cms.properties.homepage.part.not_ready.description')}
          </span>
          <span className="property-homepage__card-description">
            {t(`cms.properties.homepage.part.${type}.description`)}
          </span>
        </div>
      </div>
    );
  }
}

HomepageCard.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
};

HomepageCard.defaultProps = {
  t: () => {},
  type: '',
};
